
<div id="missions_planning_list" class="ion-content-scroll-host">
    @if(this.missionsItemsDisplayed.length > 0){    
        @for(missionItem of this.missionsItemsDisplayed; track $index){
            <app-mission-item 
                [mission]="missionItem" 
                [displayProfil]="true" 
                [displayEvaluation]="true" 
                [displayBtnAddEvaluation]="true" 
                [displayStatus]="true" 
                (onSelectMission)="this.selectMission($event)"
                (onEvaluateMission)="this.evaluateMission($event)"
                />
        }
        <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
    }
    @else{
        <marv-message type="info">{{'MSG_NO_MISSION' | translate}}</marv-message>
    }
</div>
